import { IPrice } from '../../../../common/model/IPrice';
import { IPriceDisplay } from '../model/IPlatformConfig';
import { OptionType } from '../enum/OptionType';
import dealPriceAccessor from './dealPriceAccessor';
import ICarConfigOption from '../../../../common/model/ICarConfigOption';

const pricingService = {
  isPrimaryPrice(price: IPrice, priceOptions: IPriceDisplay): boolean {
    return price.currency === priceOptions.primary.currency && price.type === priceOptions.primary.type;
  },

  isSecondaryPrice(price: IPrice, priceOptions: IPriceDisplay): boolean {
    return price.currency === priceOptions.secondary?.currency && price.type === priceOptions.secondary?.type;
  },

  addServicePlanToContext(
    options: ICarConfigOption[],
    servicePlanValue: number | null,
    setServicePlan: (value: number) => void,
  ): void {
    const servicePlan: () => ICarConfigOption | null = () =>
      options.find(
        (option: ICarConfigOption) =>
          option?.category?.category &&
          option?.category?.category.toLowerCase() === OptionType.SERVICE_PLAN.toLowerCase(),
      );

    if (servicePlan()) {
      const { basePrice: servicePlanBasePrice } = dealPriceAccessor.getFittedPrice(servicePlan().prices);
      if (servicePlanBasePrice) {
        setServicePlan(servicePlanBasePrice);
      }
    } else if (servicePlanValue) {
      setServicePlan(0);
    }
  },
};

export default pricingService;
